import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '../../../../../node_modules/@angular/forms';
import { CustomValidators } from '../../../lib/customer-validators';
import { PracticeService } from '../../../services/practice.service';

@Component({
  selector: 'app-add-mentor-to-practice',
  templateUrl: './add-mentor-to-practice.component.html',
  styleUrls: ['./add-mentor-to-practice.component.scss']
})
export class AddMentorToPracticeComponent implements OnInit {
  public memberForm: FormGroup;
  public inviteError = null;
  constructor(public dialogRef: MatDialogRef<AddMentorToPracticeComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any, private practiceService: PracticeService) {
      this.memberForm = new FormGroup({
        'email': new FormControl(null, [Validators.required, CustomValidators.validateEmailAddress])

      });
    }

  ngOnInit() {
  }

  cancel(){
    this.dialogRef.close(false);
  }

  submit(){
    this.inviteError = null;
    this.practiceService.inviteMentor(this.memberForm.get('email').value, this.data.practice.id).subscribe(res=>{
      this.dialogRef.close(true);
    },err=>{
      this.inviteError = err.error.message;
    })
  }

}
